import axios from 'axios'
import { JSON_URL } from '../../api'

export function loadIslandJson() {
  return axios.get(`${JSON_URL}register.register_island_polygon/items.json?limit=100`)
}

export function loadRegionJson() {
  return axios.get(`${JSON_URL}register.register_boundary_polygon/items.json?limit=100&dictionary_boundary_type_id=21`)
}

export function loadDistrictJson() {
  return axios.get(`${JSON_URL}register.register_boundary_polygon/items.json?limit=100&dictionary_boundary_type_id=22`)
}

export function loadSpecificDistrictJson(id) {
  return axios.get(`${JSON_URL}register.register_boundary_polygon/items.json?limit=100&boundary_parent=${id}`)
}

export function loadShehiaJson() {
  return axios.get(`${JSON_URL}register.register_boundary_polygon/items.json?limit=100&dictionary_boundary_type_id=23`)
}

export function loadSpecificShehiaJson(id) {
  return axios.get(`${JSON_URL}register.register_boundary_polygon/items.json?limit=100&boundary_parent=${id}`)
}

export function loadZoneJson() {
  return axios.get(`${JSON_URL}register.register_boundary_polygon/items.json?limit=100&dictionary_boundary_type_id=24`)
}

export function loadSpecificZoneJson(id) {
  return axios.get(`${JSON_URL}register.register_boundary_polygon/items.json?limit=100&boundary_parent=${id}`)
}

export function loadShehiaById(id) {
  return axios.get(`${JSON_URL}register.register_boundary_polygon/items.json?limit=100&id=${id}`)
}
